import React from 'react';
import { styled } from 'styled-components';

import { Case } from '../../../../shared/api/hscan/case';
import { ImageView } from '../../common/components/ImageView';
import { PatientInfoTable } from '../ImageList/PatientInfoTable';

import { PreviewImageDetailButtons } from './PreviewCaseInfoButtons';
import { PreviewImageInfoTable } from './PreviewImageInfoTable';

const CasesWrapper = styled.div`
  width: 100%;
  padding: 20px 0;
`;

const CaseWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 20px 0;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 25px;
`;

const TableWapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 17px;
  overflow-x: auto;
`;

interface PreviewImageProps {
  cases: Case[];
}

export const PreviewCases = (props: PreviewImageProps) => {
  const { cases } = props;

  return (
    <CasesWrapper>
      {cases.map((caseInfo, idx) => (
        <CaseWrapper key={`share-to-patient-case-${idx}`}>
          <ImageWrapper>
            <ImageView
              imageId={
                caseInfo?.contentIds?.length ? caseInfo.contentIds[0] : ''
              }
              width="320px"
            />
            <PreviewImageDetailButtons caseInfo={caseInfo} />
          </ImageWrapper>
          <TableWapper>
            <PatientInfoTable caseInfo={caseInfo} />
            <PreviewImageInfoTable caseInfo={caseInfo} />
          </TableWapper>
        </CaseWrapper>
      ))}
    </CasesWrapper>
  );
};
